// Player view: everything the player (or a strategy bot) may legally see.
// Strips PRNG state, seed, and per-project hidden bug state; adds the
// coverage-confidence gauge. docs/ARCHITECTURE_M0.md §2 principle 4.

import type { GameState, PlayerView, ViewProject } from "./types.js";
import { coverageOf } from "./formulas/effort.js";

export function playerView(state: GameState): PlayerView {
  const s = structuredClone(state);
  const projects: ViewProject[] = s.projects.map((p) => {
    const { hidden: _hidden, ...visible } = p;
    return { ...visible, coverage: coverageOf(p.verifEmDone, p.verifScale) };
  });
  return {
    contentVersion: s.contentVersion,
    tick: s.tick,
    monthIndex: s.monthIndex,
    cash: s.cash,
    dead: s.dead,
    deathReason: s.deathReason,
    path: s.path,
    stage: s.stage,
    people: s.people,
    nreEngineers: s.nreEngineers,
    nodes: s.nodes,
    projects,
    products: s.products,
    markets: s.markets,
    finance: s.finance,
    board: s.board,
    ipo: s.ipo,
    street: s.street,
    rivals: s.rivals,
    talent: s.talent,
    stakeholders: s.stakeholders,
    asks: s.asks,
    tools: s.tools,
    ma: s.ma,
    tree: s.tree,
    garage: s.garage,
    garageLegacy: s.garageLegacy,
    devContract: s.devContract,
    counters: s.counters,
    kpiHistory: s.kpiHistory,
  };
}
